import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117a9205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-picker" }

import { ref, watch, computed } from 'vue';
import flatPickr from 'vue-flatpickr-component';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import 'flatpickr/dist/flatpickr.css';

// 親から受け取るパラメータ

export default /*#__PURE__*/_defineComponent({
  __name: 'DateBox',
  props: {
    modelValue: null,
    disabled: { type: Boolean },
    minDate: null,
    maxDate: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: unknown): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: Date;
  disabled?: boolean;
  minDate?: Date; // 最小日
  maxDate?: Date; // 最大日
}


watch(() => [props.modelValue], init);

const model = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});



// flatpickr 設定（min/max を反映）
const computedConfig = computed(() => ({
  wrap: false as const,
  defaultDate: null,
  locale: Japanese,
  dateFormat: 'Y年m月d日(D)',
  minDate: props.minDate || null,
  maxDate: props.maxDate || null,
  disable: props.disabled ? ['*'] : [],
}));

// 表示用の日付文字列
const dateText = ref('');
watch(
  () => dateText.value,
  () => {
    model.value = toDate(dateText.value);
  }
);

const dayTime = 24 * 60 * 60 * 1000;
const isEnabledBack = computed(() => {
  const crtDt = toDate(dateText.value);
  return (
    !props.disabled &&
    (!props.minDate || props.minDate.getTime() <= crtDt.getTime() - dayTime) &&
    (!props.maxDate || crtDt.getTime() <= props.maxDate.getTime())
  );
});
const isEnabledForward = computed(() => {
  const crtDt = toDate(dateText.value);
  return (
    !props.disabled &&
    (!props.minDate || props.minDate.getTime() <= crtDt.getTime()) &&
    (!props.maxDate || crtDt.getTime() + dayTime <= props.maxDate.getTime())
  );
});

// 日にち追加
function addDay(add: number) {
  const dt = toDate(dateText.value);
  if (!dt) return;
  dt.setDate(dt.getDate() + add);
  dateText.value = toDateText(dt);
}

const regex = /(\d{4})[年/-](\d{1,2})[月/-](\d{1,2})日?/;

function toDate(str: string): Date {
  const m = str.match(regex);
  const dt = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0) : new Date(1901, 0, 1, 0, 0, 0); //< 最後はあり得ない 選択不可の日付は本日を返すため
  return dt;
}

function toDateText(dt: Date): string {
  return `${dt.getFullYear()}/${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getDate().toString().padStart(2, '0')}`;
}

function init() {
  const dt = ref(new Date(model.value));
  if (props.minDate && dt.value.getTime() < props.minDate.getTime()) dt.value = new Date(props.minDate);
  if (props.maxDate && props.maxDate.getTime() < dt.value.getTime()) dt.value = new Date(props.maxDate);
  dateText.value = toDateText(dt.value);
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["date-back", { disabled: !_unref(isEnabledBack) }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(isEnabledBack) && addDay(-1)))
    }, null, 2),
    _createVNode(_unref(flatPickr), {
      modelValue: dateText.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateText).value = $event)),
      config: _unref(computedConfig),
      class: "form-control",
      placeholder: "Select date",
      name: "date"
    }, null, 8, ["modelValue", "config"]),
    _createElementVNode("a", {
      class: _normalizeClass(["date-forward", { disabled: !_unref(isEnabledForward) }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(isEnabledForward) && addDay(1)))
    }, null, 2)
  ]))
}
}

})